// extracted by mini-css-extract-plugin
export default {"videoWrapper":"videoChatPanel_videoWrapper__ZUxCo"};